module.exports = __webpack_public_path__ + "img/dksteel_print_logo.999453b5.svg";